import styles from './OrderComplete.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { useTranslation } from 'react-i18next';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';
import Google from '../../auth/Google';
import TiktokPixel from 'tiktok-pixel';
import axios from 'axios';
import PayCancelModal from '../../components/PayCancelModal/PayCancelModal';
import PaymentProcessingModal from '../../components/PaymentProcessingModal/PaymentProcessingModal';

declare var ttq: any;
declare var fbq: (...args: any[]) => void;
declare function gtag(...args: any[]): void;

export interface IOrderDataType {
  bank: string;
  bank_account: string | null;
  bank_depositor: string;
  bank_holder: string;
  card_info: {
    card_name: string;
    card_number: string;
    card_quota: string;
  };
  delivery_price: number;
  order_name: string;
  order_date: string;
  order_id: string;
  pay_date: string;
  pay_method: string;
  pay_status: string;
  price: number;
  products: {
    amount: number;
    company_id: string;
    company_image: null | string;
    company_name: string;
    count: number;
    discount_price: number;
    image: string;
    option: string;
    order_product_id: number;
    product_id: number;
    review_request: string;
    send_company: null | string;
    send_date: null | string;
    send_number: null | string;
    send_status: string;
    status: string;
    title: string;
  }[];
  receive_address: string;
  receive_name: string;
  receive_phone: string;
  receive_state: string;
  receive_zipcode: string;
  request_memo: string;
  status: string;
  title: string;
  total_price: number;
  use_coupon: number;
  use_point: number;
  use_promotion: number;
}

const tiktokID = 'CSAV4IRC77U0JBJODGG0';

function OrderComplete() {
  const tagNum = [12, 13, 16, 17];
  const navigate = useNavigate();
  const params = useParams();
  const [ip, setIp] = useState('');
  const [orderData, setOrderData] = useState<IOrderDataType[]>();
  const [productIdList, setProductIdList] = useState<number[]>([]);
  const [payCancelModal, setPayCancelModal] = useState(false);
  const [paymentProcessingModal, setPaymentProcessingModal] = useState(false);

  useEffect(() => {
    axiosClient
      .get(`/data/order?order_id=${params.orderNumber}`)
      .then((res) => {
        if (!res.data.data.length) {
          return setPaymentProcessingModal(true);
          // alert(t('orderComplete.23'));
          // navigate('/');
        }
        setOrderData(res.data.data);
      });
  }, []);

  useEffect(() => {
    axios.get('https://geolocation-db.com/json/').then((res) => {
      setIp(res.data.IPv4);
    });
  }, []);

  useEffect(() => {
    if (!orderData) return;
    let list: number[] = [];

    let contentIds: any[] = [];
    let contentNames: any[] = [];

    orderData[0]?.products.forEach((product) => {
      if (!list.includes(product.product_id)) list.push(product.product_id);
      if (tagNum.some((num) => product.product_id === num)) {
        contentIds.push(product.product_id);
        contentNames.push(product.title);
      }
    });
    
    fbq('track', 'Purchase', {
      content_name: orderData[0].title,
      content_ids: contentIds.join(','),
      content_type: 'product',
      value: orderData[0].total_price,
      currency: 'USD',
    });
    
    gtag('event', 'purchase', {
      transaction_id: contentIds.join(','),
      currency: 'USD',
      value: orderData[0].total_price,
      items: contentIds.map((id) => ({
        item_id: id.toString(),
      })),
    });

    list.map((id) => {
      let transaction_id = '';
      let event_category = '';
      let event_label = '';
      let value = 0;
      let currency = '';
      orderData[0].products.map((product) => {
        if (id == product.product_id) {
          transaction_id = orderData[0].order_id + `_${product.product_id}`;
          event_category = product.product_id + (product.company_name || '');
          event_label = `상품구매-${product.title}(${product.product_id})${
            product.company_name && `-${product.company_name}`
          }`;
          value += product.amount;
          currency = 'USD';
        }
      });

      (window as any).gtag('event', 'purchase', {
        transaction_id,
        event_category,
        event_label,
        value,
        currency,
      });
    });

    // 광고 특정 상품 틱톡 태그 / 페이스북 픽셀 태그
    if (contentIds.length > 0) {
      const contents = contentIds.map((id, index) => ({
        content_id: id,
        content_name: contentNames[index],
      }));
      // const contentIdsString = contentIds.join(',');
      // const contentNamesString = contentNames.join(',');

      ReactPixel.track('Purchase', {
        content_ids: contentIds.join(','),
        content_type: 'product',
        value: orderData[0].total_price.toLocaleString(),
        currency: 'USD',
      });

      ttq.track('CompletePayment', {
        event_id: params.orderNumber,
        content_type: 'product',
        value: orderData[0].total_price.toLocaleString(),
        currency: 'USD',
        contents: contents,
      });
    }
    setProductIdList(list);

    let formData = new FormData();
    formData.append('action', 'buy_product');
    axiosClient
      .post('/func/survey/log', formData, {
        withCredentials: true,
      })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  }, [orderData]);
  const { t, i18n } = useTranslation();
  const [lineGuideOpen, setLineGuideOpen] = useState(false);
  return (
    <>
      <div>
        <div className={styles.header}>
          <span onClick={() => navigate('/')}>{t('productDetail.38')}</span>
        </div>
        <div className={styles.contentWrap}>
          <div className={styles.top}>
            {/* <div className={styles.logoWrap}>
              <img
                src={kakao}
                alt="카카오로고"
                onClick={() => {
                  window.open('https://pf.kakao.com/_xaxbskb', '_black');
                }}
              />
              <img
                src={whatsapp}
                alt="왓츠앱로고"
                onClick={() => {
                  window.open('https://lin.ee/kU6zF4e', '_black');
                }}
              />
            </div> */}
            {/* <span>@dr.bogam</span> */}
            <h3>{t('orderComplete.1')}</h3>
            <p dangerouslySetInnerHTML={{ __html: t('orderComplete.22') }}></p>
            <div className={styles.btns}>
              <button
                onClick={() => navigate(`/orderDetail/${params.orderNumber}`)}
              >
                {t('orderComplete.2')}
              </button>
              <button onClick={() => navigate('/')}>
                {t('orderComplete.3')}
              </button>
            </div>
          </div>
          <div className={styles.orderNumberWrap}>
            <span>
              {t('orderComplete.4')} : {orderData && orderData[0]?.order_id}{' '}
            </span>
            <span>
              {orderData &&
                orderData[0]?.order_date.substring(0, 10).replace(/-/gi, '.')}
            </span>
          </div>
          <ul className={styles.orderItemList}>
            {orderData &&
              productIdList.map((id) => {
                let optionList: string[] = [];
                let count = 0;
                let productImage = '';
                let productName = '';
                orderData[0].products
                  .filter((product) => product.product_id == id)
                  .map((product) => {
                    optionList.push(product.option);
                    count += product.count;
                    productImage = product.image;
                    productName = product.title;
                  });
                return (
                  <li key={id}>
                    <div
                      className={styles.productThumbnailWrap}
                      onClick={() => navigate(`/productDetail/${id}`)}
                    >
                      <img src={productImage} alt="thumbnail" />
                    </div>
                    <div className={styles.productInfoWrap}>
                      <span className={styles.productName}>{productName}</span>
                      <div className={styles.optionListWrap}>
                        <span>{t('orderComplete.5')}</span>
                        <ul>
                          {optionList.map((option, idx) => (
                            <li key={idx}>{option}</li>
                          ))}
                        </ul>
                      </div>
                      <div className={styles.countWrap}>
                        <span>{t('orderComplete.6')}</span>
                        <span> {count}</span>
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
          <div className={styles.deliveryInfoWrap}>
            <h3 className={styles.sectionTitle}>{t('orderComplete.7')}</h3>
            <div className={styles.deliveryInfo}>
              <div className={styles.line}>
                <div className={styles.infoWrap}>
                  <span>{t('orderComplete.8')}</span>
                  <span>{orderData && orderData[0]?.order_name}</span>
                </div>
                <div className={styles.infoWrap}>
                  <span>{t('orderComplete.9')}</span>
                  <span>{orderData && orderData[0]?.receive_name}</span>
                </div>
              </div>
              <div className={styles.infoWrap}>
                <span>{t('orderComplete.10')}</span>
                <span>{orderData && orderData[0]?.receive_phone}</span>
              </div>
              <div className={styles.infoWrap}>
                <span>{t('orderComplete.11')}</span>
                <span>
                  {orderData && orderData[0]?.receive_address}{' '}
                  {orderData && orderData[0]?.receive_state}
                </span>
              </div>
              <div className={styles.infoWrap}>
                <span>{t('orderComplete.12')}</span>
                <span>{orderData && orderData[0]?.request_memo}</span>
              </div>
            </div>
          </div>
          <div className={styles.priceInfoWrap}>
            <h3 className={styles.sectionTitle}>{t('orderComplete.13')}</h3>
            <div className={styles.priceInfo}>
              <div>
                <span>{t('orderComplete.14')}</span>
                <span>
                  $ {orderData && orderData[0]?.price.toLocaleString()}
                </span>
              </div>
              <div>
                <span>{t('orderComplete.15')}</span>
                <span>
                  ${' '}
                  {orderData &&
                    (
                      orderData[0]?.use_coupon +
                      orderData[0]?.use_point +
                      orderData[0]?.use_promotion
                    ).toLocaleString()}
                </span>
              </div>
              <div>
                <span>{t('orderComplete.16')}</span>
                <span>
                  {orderData &&
                    (orderData[0]?.delivery_price == 0
                      ? t('orderComplete.21')
                      : '$ ' + orderData[0]?.delivery_price.toLocaleString())}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.totalPrice}>
            <span>{t('orderComplete.13')}</span>
            <span>
              ${orderData && orderData[0]?.total_price.toLocaleString()}
            </span>
          </div>
          <div className={styles.payMethodInfoWrap}>
            <h3>{t('orderComplete.17')}</h3>
            {orderData && orderData[0]?.card_info.card_name && (
              <span>
                {t('orderComplete.18')} ({orderData[0]?.card_info.card_name}/
                {orderData[0].card_info.card_quota == '00'
                  ? t('orderComplete.19')
                  : orderData[0].card_info.card_quota + t('orderComplete.20')}
                )
              </span>
            )}
            {/* <span>paypal</span> */}
          </div>
        </div>
      </div>
      {payCancelModal && <PayCancelModal closer={setPayCancelModal} />}
      {paymentProcessingModal && <PaymentProcessingModal closer={setPaymentProcessingModal} />}
    </>
  );
}
export default OrderComplete;
